import { Repository, EntityRepository } from 'typeorm';
import {CycleChecker } from '../cycle-checker.entity';

@EntityRepository(CycleChecker)
export class CycleCheckerRepository extends Repository<CycleChecker>{
   
}
